import React, { Component } from 'react';
import {
  InteractionManager,
  Linking,
  PixelRatio,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';

import { FlatList, FontAwesomeIcon } from '../modules';

import Empty from '../common/Empty';
import UserUtils from '../utils/UserUtils';
import NavigatorUtils from '../utils/NavigatorUtils';
import APIClient from '../utils/APIClient';

class NotificationListScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {routes, params} = navigation.state;
    return {
      tabBarIcon: ({focused, tintColor}) => {
        return (
          <FontAwesomeIcon
            name='bell'
            size={26}
            color={tintColor}/>
        );
      },
      tabBarVisible: !routes || routes.length <= 1,

      title: 'Thông báo',
      headerBackTitle: null,
    };
  };

  constructor (props) {
    super(props);

    this.state = {
      refreshing: false,
      items: [],
      noitem: false,
    };
    this._page = -1;
    this._loading = false;
  }

  componentDidMount () {
    InteractionManager.runAfterInteractions(() => {
      this._refreshData(true);
    });

    const {credential} = this.props;
    UserUtils.resetNotificationCount(credential);
  }

  componentWillUnmount () {
  }

  _refreshData (refreshing) {
    if (this._loading) {
      return;
    }

    this._resetData(refreshing);
    this._loadData();
  }

  _resetData (refreshing) {
    this._loading = false;
    this._page = 1;
    this.setState({
      refreshing: refreshing,
      items: [],
      noitem: false,
    });
  }

  _loadData = async () => {
    if (this._loading || this._page <= 0) {
      return;
    }

    this._loading = true;

    const params = {
      page: this._page,
      limit: 20,
    };
    const {response, error} = await APIClient.GET('/notifications', params);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    let {items, noitem} = this.state;
    if (response && response.response) {
      const newItems = response.response;
      if (newItems.length > 0) {
        items = items.concat(newItems);
        this._page++;
        this.setState({
          items: items,
        });
      } else {
        this._page = -1;
      }
    } else {
    }

    noitem = _.isEmpty(items);
    this._loading = false;
    this.setState({
      refreshing: false,
      noitem: noitem,
    });
  }

  _keyExtractor = item => item.id;

  _onRefresh = () => this._refreshData(true);

  _onEndReached = ({distanceFromEnd}) => {
    if (distanceFromEnd < 0) {
      return;
    }
    this._loadData();
  };

  _renderItem = ({item, index}) => {
    return (
      <NotificationItem
        item={item}
        onClick={this._handleClickItem}/>
    );
  };

  _handleClickItem = (item) => {
    const {data} = item;
    if (!data) {
      return;
    }

    const route = NavigatorUtils.parseRoute(item.data);
    console.log('route: ' + JSON.stringify(route));
    if (!route) {
      return;
    }
    if (Platform.OS === 'web') {
      const {path} = route;
      if (!_.isEmpty(path)) {
        this.props.history.push(path);
      }
    } else {
      if (route.routeName === 'Browser') {
        const {url} = route.params;
        if (!_.isEmpty(url)) {
          Linking.openURL(url).catch(error => console.log('error: ', error));
        }
        return;
      }

      const {navigation} = this.props;
      navigation.navigate(route.routeName, route.params);
    }
  };

  render () {
    const {user} = this.props;
    const isSignedIn = UserUtils.isSignedIn(user);
    const {refreshing, items, noitem} = this.state;
    return (
      <View
        style={[
          styles.container, {
            backgroundColor: isSignedIn ? '#f6efdb' : '#ffffff',
          }]}>
        <FlatList
          refreshing={refreshing}
          data={items}
          onEndReachedThreshold={0.5}
          keyExtractor={this._keyExtractor}
          onRefresh={this._onRefresh}
          onEndReached={this._onEndReached}
          renderItem={this._renderItem}
          style={styles.list}/>

        {noitem && <Empty
          text='Không có thông báo, bấm để thử lại'
          onClick={() => this._refreshData(false)}/>}
      </View>
    );
  }
}

class NotificationItem extends React.PureComponent {

  _handleClick = () => {
    const {item, onClick} = this.props;
    if (onClick) {
      onClick(item);
    }
  };

  render () {
    const {item} = this.props;
    const {title, body} = item;
    return (
      <TouchableOpacity
        activeOpacity={0.75}
        onPress={this._handleClick}
        style={styles.item}>
        <Text
          style={styles.itemTitleText}>
          {title}
        </Text>
        <Text
          style={styles.itemBodyText}>
          {body}
        </Text>
        <View
          style={styles.itemDivider}/>
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },

  list: {
    flex: 1,
  },
  item: {
    padding: 8,
  },
  itemTitleText: {
    color: '#000000',
    fontSize: 16,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
  },
  itemBodyText: {
    color: '#000000',
    fontSize: 14,
    fontWeight: '100',
    backgroundColor: 'transparent',
  },
  itemDivider: {
    position: 'absolute',
    left: 0, bottom: 0, right: 0,
    backgroundColor: '#6b7adc',
    ...Platform.select({
      web: {
        height: 1,
      },
      ios: {
        height: 1 / PixelRatio.get(),
      },
      android: {
        height: 1 / PixelRatio.get(),
      },
    }),
  },
});

const mapStateToProps = (state) => {
  return {
    credential: state.user.credential,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(
  NotificationListScreen);



// WEBPACK FOOTER //
// ./src/notification/NotificationListScreen.js